<template>
       <form role="form">
        <div class="container-fluid shadow">
            <div class="row">
               
                <div class="row">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-1"></div>
                            <div class="col-md-9"></div>
                            <div class="col-md-1"></div>
                            <div class="col-md-1"></div>
                        </div>
                   
                        <div class="row">
                            <div class="col-md">
                                <div class="form-group">
                                    <div class="col-sm-3 col-form-label">{{addProductOption.quantitaLbl}}</div>
                                    <div class="col-sm-9">
                                
                                        <div class="input-group" style="padding: 7px;">
                                            <span class="input-group-btn">
                                            <button type="button" class="btn btn-default2 addq-btn-number" data-type="minus" data-field="modalQuant[1]">
                                                <span :class="this.$root.icons.minus"></span>
                                            </button>
                                            </span>
                                            
                                            <input type="number" id="quantita2Id" name="modalQuant[1]" class="form-control addq-input-number" style="text-align: center;" value=""> 

                                            <span class="input-group-btn">
                                            <button type="button" class="btn btn-default2 addq-btn-number" data-type="plus" data-field="modalQuant[1]">
                                                <span :class="this.$root.icons.plus"></span>
                                            </button>
                                            </span>
                                        </div>
                                
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                         <div class="row">
                            <div class="col-md-1"></div>
                            <div class="col-md-9"></div>
                            <div class="col-md-1"></div>
                            <div class="col-md-1">&nbsp;</div>
                        </div>
                      
                        <div class="row">
                            <div class="col-md-4"></div>
                            <div class="controls col-sm-4">
                                <button @click.prevent="confirmClick"  class="btn btn-primary-default" style="width: 100%; padding-left: 6px; padding-right: 6px;">{{addProductOption.confirmBtnLbl}}</button>
                            </div>
                            <div class="controls col-sm-4">
                                <button @click.prevent="cancelClick"  class="btn btn-light" style="width: 100%">{{addProductOption.cancelBtnLbl}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import { eventBus } from "../../../eventbus";
import InputW from '../../dynamic/inputWrapper/inputWrapper.vue'
import FormMixin from '../../dynamic/inputWrapper/formMixin.js'
//const searcher = require('products_searcher');

export default {
    mixins: [FormMixin],
     props: {
        rowData: Object, 
        minQuantity: { Number,
            default: 1
        },
        maxQuantity: {Number,
            default: 9999999
        },
    },
    components: {
        InputW,
    },
    data: function () {
        var vm = this;
        return {
            addProductOption: {
                quantitaLbl: vm.$Jed.firstUpperTranslate('qty'),
                confirmBtnLbl: vm.$Jed.firstUpperTranslate('add'),
                cancelBtnLbl: vm.$Jed.firstUpperTranslate('cancel'),
            },
        }
    },
    mounted: function() {
        var vm = this;
        //soruce: www.codeply.com/go/2VmBU7TanF/bootstrap-plus-minus-counter-input
        $('.addq-btn-number').click(function(e){
            var fieldName = $(this).attr('data-field'),
                type = $(this).attr('data-type'),
                input = $("input[name='"+fieldName+"']"),
                currentVal = parseFloat(input.val());
            if (!isNaN(currentVal)) {
                if(type == 'minus') {
                    if(currentVal > input.attr('min')) {
                        if(vm.rowData.refObj.mqd){
                            input.val((currentVal - 0.1).toFixed(1)).change();
                        }else if(vm.rowData.refObj.pib){
                            input.val(currentVal - vm.rowData.refObj.pib).change();
                        }else{
                            input.val(currentVal - 1).change();
                        }
                    } 
                    if(parseFloat(input.val()) == input.attr('min')) {
                        $(this).attr('disabled', true);
                    }
                } else if(type == 'plus') {
                    if(currentVal < input.attr('max')) {
                        if(vm.rowData.refObj.mqd){
                            input.val((currentVal + 0.1).toFixed(1)).change();
                        }else if(vm.rowData.refObj.pib){
                            input.val(currentVal + vm.rowData.refObj.pib).change();
                        }else{
                            input.val(currentVal + 1).change();
                        }
                    }
                    if(parseFloat(input.val()) == input.attr('max')) {
                        $(this).attr('disabled', true);
                    }
                }
            } else {
                input.val(0);
            }
        });

        $('.addq-input-number').focusin(function(){
            $(this).data('oldValue', $(this).val());
        });

        $('.addq-input-number').change(function() {
            var minValue =  parseFloat($(this).attr('min')),
                maxValue =  parseFloat($(this).attr('max')),
                valueCurrent = parseFloat($(this).val()),
                name = $(this).attr('name');
            if(valueCurrent % 1 != 0){ //il valore inserito è decimale?
                if(vm.rowData.refObj.mqd){
                    if(valueCurrent >= minValue) {
                        $(".addq-btn-number[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
                    }else{
                        console.log('addq - the minimum value was reached');
                        $(this).val(vm.minQuantity);
                    }
                    if(valueCurrent <= maxValue) {
                        $(".addq-btn-number[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
                    }else{
                        console.log('addq - the maximum value was reached');
                        $(this).val($(this).data('oldValue'));
                    }
                }else{
                    $(this).val(vm.minQuantity);
                }
            }else{
                if(vm.rowData.refObj.pib && (valueCurrent % vm.rowData.refObj.pib != 0)){ //il valore non è multiplo dei pezzi per confezione
                    var mult = parseInt(valueCurrent / vm.rowData.refObj.pib)
                    var correct = vm.rowData.refObj.pib * mult
                    $(this).val(correct);
                }
                if(valueCurrent >= minValue) {
                    $(".addq-btn-number[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
                }else{
                    console.log('addq - the minimum value was reached');
                    $(this).val(vm.minQuantity);
                }
                if(valueCurrent <= maxValue) {
                    $(".addq-btn-number[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
                }else{
                    console.log('addq - the maximum value was reached');
                    $(this).val($(this).data('oldValue'));
                }
            }
            
        });

        $(".addq-input-number").keydown(function (e) {
            //se si preme invio, metto il prodotto in carrello
            if (e.keyCode == 13 ){
                //DO nothing
                //gestire eventualmente l'inserimento in carrello
                /* eventBus.$emit('putInCart');
                e.stopImmediatePropagation() */
            }
            //se premo un altro tasto, non fare niente
            // Allow: backspace, delete, tab, escape and .
            if(vm.rowData.refObj.mqd){ //permetto l'inserimento di punti e virgole
                if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190, 110, 188]) !== -1 ||
                    // Allow: Ctrl+A
                    (e.keyCode == 65 && e.ctrlKey === true) || 
                    // Allow: home, end, left, right
                    (e.keyCode >= 35 && e.keyCode <= 39)) {
                    // let it happen, don't do anything
                    return;
                }
            }else{
                if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
                    // Allow: Ctrl+A
                    (e.keyCode == 65 && e.ctrlKey === true) || 
                    // Allow: home, end, left, right
                    (e.keyCode >= 35 && e.keyCode <= 39)) {
                    // let it happen, don't do anything
                    return;
                }
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        });

    },
    methods: {
            updateData() {
                var vm = this;
                $("#quantita2Id").val(this.rowData == null ? 1 : this.rowData.qty);
            },
            confirmClick () {
                var vm = this;
                this.rowData.qty = parseFloat($("#quantita2Id").val());

                if( this.rowData.qty < this.minQuantity || this.rowData.qty >  this.maxQuantity){
                    //alert('Superata la quantità minima o massima ammessa per questo prodotto');
                    eventBus.$emit('alert', {
                        message: this.$Jed.firstUpperTranslate('Warning: minimum quantity is %1$s', null, {key: null, string: this.minQuantity}),
                        type: "warning",
                        action: ''
                    })
                    return;
                }

                if(this.$Behaviors.cartProductSource == 'catalog'){
                    //uso rowData.cod per fare searchById e ottenere il prezzo
                    this.$root
                        .microservice({
                            role: "catalog",
                            cmd: "SearchById",
                            params: {
                                sid: this.rowData.cod,
                                labels: ['des'],
                                prod_info: ['uni'],
                                saleability: true
                            }
                        })
                        .then(
                            response => {
                                var res = response.body;
                                try {
                                res = JSON.parse(response.body);
                                } catch (err) {}

                                if (res.answer && res.answer.length > 0) {
                                    var prod = res.answer[0];
                                    vm.rowData.refObj.origin = prod.origin ? prod.origin : 0
                                    vm.rowData.refObj.pri = prod.pri ? prod.pri : 0
                                    vm.rowData.refObj.cd1 = prod.cd1 ? prod.cd1 : 0
                                    vm.rowData.refObj.cd2 = prod.cd2 ? prod.cd2 : 0
                                    vm.rowData.csy = prod.csy ? prod.csy : vm.$root.token.valuta
                                    vm.rowData.mqt = vm.rowData.refObj.mqt ? vm.rowData.refObj.mqt : 0
                                    vm.rowData.uni = prod.uni
                                    vm.$emit("onAddQuantityEvent", vm.rowData);
                                }
                            },
                            err => {
                                this.ready = true;
                                //vedi gestione errore in main.js > microservice
                            }
                        )
                        .catch(err => {
                            console.log(err);
                            var msg = err && err.body && err.body.error ? err.body.error : ''
                            eventBus.$emit('alert', {
                                message: "Application caught an error <br> <h5>Details: " + "catalog.SearchById - " + msg +'</h5>',
                                type: "error",
                                action: ''
                            })
                        })
                }else{
                    vm.$emit("onAddQuantityEvent", vm.rowData);
                }
            },
            cancelClick () {
                this.$emit("onCancelAddQuantityEvent");
            }
    }
}
</script>

<style>



/* .form-control {
    background-color: white !important;
    cursor: context-menu !important;
    height: 34px;
} */

/* .form-control:focus {
    border-color: #d2d6de !important;
} */


.btn-default2 {
    background-color: #f4f4f4;
    color: #444;
}
.center{
    width: 150px;
    margin: 40px auto;
  
}

</style>



// WEBPACK FOOTER //
// src/components/views/shopcart/AddQuantity.vue?18daa443